import TrendStatusHelper from "./TrendStatusHelper";

export default class ConfirmationDateHelper {
  static EVENT_TYPES = {
    BREAKOUT: "breakout",
    BREAKDOWN: "breakdown"
  };

  static getEventArrow(eventType) {
    if (eventType === ConfirmationDateHelper.EVENT_TYPES.BREAKOUT) {
      return {
        direction: TrendStatusHelper.directions.upRight,
        color: TrendStatusHelper.arrowColors.green
      };
    }

    if (eventType === ConfirmationDateHelper.EVENT_TYPES.BREAKDOWN) {
      return {
        direction: TrendStatusHelper.directions.downRight,
        color: TrendStatusHelper.arrowColors.red
      };
    }

    return null;
  }
}
